import React from 'react';
import '@atlaskit/css-reset';
import AutomationApp from '@atlassian/jira-automation';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GlobalAutomationApp(_props: Record<any, any>) {
	return (
		<>
			<MarkProductStart />
			<AuthenticationCheck>
				<AutomationApp />
			</AuthenticationCheck>
		</>
	);
}

export default GlobalAutomationApp;
